module.exports = __webpack_public_path__ + "img/banner_exhibition_2.9cf87a70.png";